import { subscriptionPlans } from '@/common/constants'

import AboutToExpire from './AboutToExpire/AboutToExpire'
import CurrentMonthExchanges from './CurrentMonthExchanges/CurrentMonthExchanges'
import CurrentMonthInstantTransactions from './CurrentMonthInstantTransactions/CurrentMonthInstantTransactions'
import CurrentMonthInstantRefunds from './CurrentMonthRefunds/CurrentMonthRefunds'
import CurrentMonthTransactions from './CurrentMonthTransactions/CurrentMonthTransactions'
import ForReview from './ForReview/ForReview'
import OnHold from './OnHold/OnHold'
import PendingApproval from './PendingApproval/PendingApproval'

export const getTransactionsMetrics = ({ metrics, subscriptionPlan, onClickInStats }) => {
  return [
    {
      Component: <OnHold onHold={metrics?.transactions_on_hold} onClick={onClickInStats} />,
      show: true,
    },
    {
      Component: <ForReview forReview={metrics?.transactions_for_review} onClick={onClickInStats} />,
      show: true,
    },
    {
      Component: <PendingApproval pendingApproval={metrics?.transactions_pending_approval} onClick={onClickInStats} />,
      show: true,
    },
    {
      Component: <AboutToExpire expired={metrics?.transactions_about_to_expire} onClick={onClickInStats} />,
      show: subscriptionPlan !== subscriptionPlans.basic,
    },
  ].filter(transactionMetric => transactionMetric.show)
}

export const getLas30DaysTransactions = ({ metrics, subscriptionPlan, onClickInStats }) => {
  return [
    {
      Component: (
        <CurrentMonthTransactions transactions={metrics?.last_30_days_transactions} onClick={onClickInStats} />
      ),
      show: true,
    },
    {
      Component: (
        <CurrentMonthInstantTransactions
          transactions={metrics?.last_30_days_instant_percentage}
          onClick={onClickInStats}
        />
      ),
      show: subscriptionPlan !== subscriptionPlans.basic,
    },
    {
      Component: <CurrentMonthInstantRefunds refunds={metrics?.last_30_days_refunds} onClick={onClickInStats} />,
      show: true,
    },
    {
      Component: <CurrentMonthExchanges exchanges={metrics?.last_30_days_exchanges} onClick={onClickInStats} />,
      show: true,
    },
  ].filter(transactionMetric => transactionMetric.show)
}
